export default __webpack_public_path__ + "static/media/symfony-original.2aba282d.svg";